<template>
  <div
    :style="styles"
    ref="box"
    v-on="$listeners"
    :class="[
      'warehouse-view-table-box',
      {
        'warehouse-view-table-box-selected': selected,
      },
      wrapClass,
    ]"
  >
    <slot></slot>
    <template v-if="canResize">
      <div
        @click.prevent.stop
        @mousedown.prevent.stop="onMouseDownGrip($event, 'x')"
        @mouseup.stop.prevent="onMouseDownFromGrip"
        class="warehouse-view-table-box-grip warehouse-view-table-box-grip-right"
      ></div>
      <div
        @mousedown.prevent="onMouseDownGrip($event, 'y')"
        @mouseup.prevent.stop="onMouseDownFromGrip"
        @click.prevent
        class="warehouse-view-table-box-grip warehouse-view-table-box-grip-bottom"
      ></div>
    </template>
  </div>
</template>

<script>
import { setUnitSize, trueSet } from "@/utils/pureFunctions";
import { DEFAULT_STILLAGE_BOX_SIZE } from "@/utils/constants";

const DEFAULT_BOX_HANDLER_DATA = {
  grip: null,
  rtl: null,
  startPosition: null,
};

let boxHandlerData = {
  ...DEFAULT_BOX_HANDLER_DATA,
};

export default {
  name: "warehouse-stillage-box",
  props: {
    canResize: {
      type: Boolean,
      default: false,
    },
    item: {},
    selected: {
      type: Boolean,
      default: false,
    },
    width: {
      default: DEFAULT_STILLAGE_BOX_SIZE,
    },
    height: {
      default: DEFAULT_STILLAGE_BOX_SIZE,
    },
  },
  computed: {
    styles() {
      return {
        width: setUnitSize(this.width),
        height: setUnitSize(this.height),
      };
    },
    wrapClass() {
      if (this.isFulled) {
        return "warehouse-view-table-box-error";
      } else if (this.isEmpty) {
        return "warehouse-view-table-box-success";
      } else {
        return "warehouse-view-table-box-warning";
      }
    },
    isFulled() {
      return this.item && trueSet(this.item.full);
    },
    isEmpty() {
      return this.item && !trueSet(this.item.hasProduct);
    },
  },
  methods: {
    onMouseDownGrip(e, rtl) {
      e.preventDefault();
      e.stopPropagation();
      boxHandlerData.grip = document.createElement("span");
      boxHandlerData.grip.style.background = "var(--primary)";
      boxHandlerData.grip.style.position = "absolute";
      boxHandlerData.rtl = rtl;
      if (rtl === "x") {
        boxHandlerData.grip.style.width = "2px";
        boxHandlerData.grip.style.height = "60px";
        boxHandlerData.startPosition = e.pageX;
        boxHandlerData.grip.style.top = e.pageY - 30 + "px";
        boxHandlerData.grip.style.left = e.pageX + "px";
      } else {
        boxHandlerData.grip.style.width = "60px";
        boxHandlerData.grip.style.height = "2px";
        boxHandlerData.grip.style.top = e.pageY + "px";
        boxHandlerData.grip.style.left = e.pageX - 30 + "px";
        boxHandlerData.startPosition = e.pageY;
      }
      document.body.append(boxHandlerData.grip);
      document.addEventListener("mouseup", this.onMouseDownFromGrip);
      document.addEventListener("mousemove", this.onMouseMove);
    },
    onMouseDownFromGrip(e) {
      e.preventDefault();
      e.stopPropagation();
      if (boxHandlerData.grip) {
        const { box } = this.$refs;
        if (boxHandlerData.rtl === "x") {
          const width =
            box.clientWidth + (e.pageX - boxHandlerData.startPosition);
          this.$emit(
            "changeWidth",
            width < DEFAULT_STILLAGE_BOX_SIZE
              ? DEFAULT_STILLAGE_BOX_SIZE
              : width
          );
        } else {
          const height =
            box.clientHeight + (e.pageY - boxHandlerData.startPosition);
          this.$emit(
            "changeHeight",
            height < DEFAULT_STILLAGE_BOX_SIZE
              ? DEFAULT_STILLAGE_BOX_SIZE
              : height
          );
        }
        boxHandlerData.grip.remove();
        boxHandlerData.grip = null;
      }
      this.unbindEvents();
      boxHandlerData = { ...DEFAULT_BOX_HANDLER_DATA };
    },
    unbindEvents() {
      document.removeEventListener("mousemove", this.onMouseMove);
      document.removeEventListener("mouseup", this.onMouseDownFromGrip);
    },
    onMouseMove(e) {
      e.preventDefault();
      e.stopPropagation();
      if (boxHandlerData.rtl === "x") {
        boxHandlerData.grip.style.left = e.pageX + "px";
      } else {
        boxHandlerData.grip.style.top = e.pageY + "px";
      }
    },
  },
};
</script>
